(function () {
    "use strict";


    // @ngInject
    function RtsManagerCtor(APIService, Routes, ModelFactory, UsersManager, $q, moment, _) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this.Routes = Routes;
        // this.RepositoryService = RepositoryService;
        // this.UsersManager = UsersManager;
        // this.moment = moment;
        // PubSubService.ventMyBitchUp(this);

        this._ = _;

        this.eventsMasterCollection = false;
        this.eventsToShow = false;
        this.lastSortColumn = '';
    }


    Services.RtsManager = Class(Services.BaseModelManager, {

        constructor: RtsManagerCtor,

        createOrUpdateChapter: function createOrUpdateChapter(chapter) {

            var data = chapter.dataOnly();

            if (chapter.isNew) {
                var url = this.Routes.v2_malkut_create_rts_chapter_path();
                return this.apiCreate(url, data, chapter, true);
            } else {
                var url = this.Routes.v2_malkut_update_rts_chapter_path(chapter._id);
                return this.apiUpdate(url, data, chapter, true);
            }
        },

        deleteChapter: function deleteChapter(chapter) {
            var url = this.Routes.v2_malkut_delete_rts_chapter_path(chapter._id);

            return this.apiDelete(url);
        },

        fetchChapters: function fetchChapters() {
            
            var chaptersCollection = this.ModelFactory.newCollectionByModelName('RtsChapterModel');
            var url = this.Routes.v2_malkut_get_rts_chapters_path();
            this.apiFetchCollection(url, null, chaptersCollection, true);
            return chaptersCollection;
        }
    });
}());